import { kebabCase } from 'lodash-es';

import type { Nullable, Undefinable } from '@zen/utils/typescript';

import { BookingScope, IncotermsValue } from './types';

const DEFAULT_BOOKING_SCOPE: BookingScope = BookingScope.REQUESTED;

const bookingScopes: BookingScope[] = Object.values(BookingScope);

export const getBookingScopeSlug = (scope: BookingScope): string => kebabCase(scope);

export const getBookingScopeFromSlug = (slug: Undefinable<string>): BookingScope => {
  const matchingScope: Undefinable<BookingScope> = bookingScopes.find(
    (scope: BookingScope): boolean => getBookingScopeSlug(scope) === slug
  );

  return matchingScope ?? DEFAULT_BOOKING_SCOPE;
};

export const incotermsSelectLabelMapping: Record<IncotermsValue, string> = {
  [IncotermsValue.CFR]: 'CFR — Cost and Freight',
  [IncotermsValue.CIF]: 'CIF — Cost, Insurance and Freight',
  [IncotermsValue.CIP]: 'CIP — Carriage and Insurance Paid To',
  [IncotermsValue.CPT]: 'CPT — Carriage Paid To',
  [IncotermsValue.DAP]: 'DAP — Delivered at Place',
  [IncotermsValue.DAT]: 'DPU — Delivered at Place Unloaded',
  [IncotermsValue.DDP]: 'DDP — Delivered Duty Paid',
  [IncotermsValue.EXWORKS]: 'EXW — Ex Works',
  [IncotermsValue.FAS]: 'FAS — Free Alongside Ship',
  [IncotermsValue.FCA]: 'FCA — Free Carrier',
  [IncotermsValue.FOB]: 'FOB — Free on Board'
};

export const getIncotermLabel = (incoterm: Nullable<IncotermsValue>): Nullable<string> => {
  if (!incoterm) {
    return null;
  }

  return incotermsSelectLabelMapping[incoterm];
};
